<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add action</span>
  </a>
</ng-template>

<smart-table [headers]="headers"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [source]="source">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="action" let-item>
    <td>
      {{ item.action?.key }} <br>
      <small class="text-muted">{{ item.action?.id }}</small>
    </td>
  </ng-template>

  <ng-template smartTableColumn="count" let-item>
    <td>
      {{ item.circleCount }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="updatedAt" let-item>
    <td>
      {{ item.updatedAt | moment }}
    </td>
  </ng-template>
  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>


  <ng-template smartTableColumn="completed" let-item>
    <td>
      <badge-exist existText="Completed" [item]="item.completed"></badge-exist>
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


